export default {"src":"/_next/static/media/Group-28011.dc4bc600.svg","height":11,"width":11};